import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Raven from 'raven-js';
import { useEffect, useMemo } from 'react';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import { REQUEST_SEAT_UPGRADE } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { RequestSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { getUpgradeDataTrackingProperties, mapPurchaseMotionApiName, trackPotentialBannerInteraction } from 'ui-addon-upgrades/ums/utils';
import { omit } from 'ui-addon-upgrades/utils';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { requestSeatUpgrade } from '../_core/upgrade/requestSeatUpgrade';
import { REQUEST_SEAT } from '../_core/purchaseMotions/PurchaseMotionTypes';
import { trackPurchaseMotionFailure } from '../_core/utils/metricUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const UIRequestSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData,
    showModal,
    canViewNewSeats,
    onClick = () => {},
    onSuccess = () => {},
    onFailure = () => {},
    showSeatSelector
  } = props;
  const upgradeDataWithApiName = useMemo(() => {
    return Object.assign({}, upgradeData, {
      apiName: mapPurchaseMotionApiName(canViewNewSeats, upgradeData.upgradeProduct, 'UIRequestSeatButton', upgradeData.apiName)
    });
  }, [canViewNewSeats, upgradeData]);
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'showModal', 'onClick', 'onSuccess', 'onFailure', 'usageLimitBannerData', 'canViewNewSeats', 'showSeatSelector', 'ownedHubsAndSuiteApiNames');
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed request seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeDataWithApiName)));
  }, [upgradeDataWithApiName, usageLimitBannerData, level]);
  const onClickHandler = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeDataWithApiName)));
    tracker.track('interaction', Object.assign({
      action: 'clicked request seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeDataWithApiName)));
    const {
      pointType,
      upgradeKey
    } = upgradeDataWithApiName;
    trackPotentialBannerInteraction(pointType, upgradeKey).catch(error => {
      Raven.captureException(new Error('Failed to submit interaction from UIRequestSeatButton'), {
        extra: {
          message: error.message,
          uniqueId: upgradeData.uniqueId
        }
      });
    });
    if (!showModal) {
      onClick();
      const apiNameToUse = canViewNewSeats && upgradeData.apiName ? upgradeData.apiName : UpgradeProductToApiNameMap[upgradeDataWithApiName.upgradeProduct];
      requestSeatUpgrade({
        apiName: apiNameToUse
      }).then(() => onSuccess()).catch(() => {
        trackPurchaseMotionFailure({
          uniqueId: upgradeData.uniqueId,
          apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct],
          purchaseMotion: REQUEST_SEAT
        });
        onFailure();
      });
    }
  };

  // UMS Upgrade Modal does the request seat api call itself rather than opening the request seat modal
  if (!showModal) {
    return /*#__PURE__*/_jsx(UIButton, Object.assign({
      "data-reagan-primary-cta": true
    }, propsToPass, {
      onClick: onClickHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      })
    }));
  }
  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: TEAM,
    modalType: REQUEST_SEAT_UPGRADE,
    upgradeData: upgradeData,
    onClick: onClickHandler,
    showSeatSelector: showSeatSelector,
    canViewNewSeats: canViewNewSeats,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      "data-reagan-primary-cta": true,
      "data-test-id": "request-seat-button"
    }, propsToPass, {
      href: getPaidUserManagementUrl(),
      target: "_blank",
      onClick: onClickHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      })
    }))
  });
};
UIRequestSeatButton.defaultProps = {
  showModal: true
};
UIRequestSeatButton.propTypes = RequestSeatButtonPropsInterface;
export default UIRequestSeatButton;